import { AuthStepWrapper } from '@/bundle/Auth/ui/AuthStep/styles';
import { COLORS } from '@/styles/colors';
import { flex } from '@/styles/layout';
import styled from 'styled-components';
import { media } from '@/styles/responsive';

export const AgreementWrapper = styled(AuthStepWrapper)`
  max-width: 900px;
  width: 100%;
  max-height: 67vh;
  height: 100%;
  padding: 0;
  ${flex({ flexDirection: 'column' })};

  ${media.mobile`
    margin-top: 0;
    max-height: 75vh;
  `}
`;

export const AgreementHeader = styled.div`
  ${flex({ justifyContent: 'space-between', alignItems: 'baseline' })};
  padding: 20px 26px 20px 42px;
  border-bottom: 1px solid ${COLORS.grey[300]};
  column-gap: 12px;

  ${media.mobile`
    padding: 16px;
    ${flex({ flexDirection: 'column', alignItems: 'center' })};
    row-gap: 8px;
  `}
`;

export const AgreementFooter = styled.div`
  ${flex()};
  border-top: 1px solid ${COLORS.grey[300]};
  padding: 16px 42px;

  ${media.mobile`
    padding: 16px;
  `}
`;
